// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bs-text-color: #ffe6c8;
  --bs-light-green: #d5dec1;
  --bs-bg-dark: black ;
  --bs-bg-body: #008080;
  --bs-text-body: #e2eecc;
}

.bg-primarycolor {
  background-color: var(--bs-bg-body) !important;
  color: var(--bs-text-body) !important;
}



.bg-dark {
  background: black !important;
}

.bg-black {
  background: black !important;
  color:#ffe6c8 !important;
}


.bg-tranparent{
  background: transparent !important;

}
.light-col{
  color: #ffe6c8!important; 
}

.studentSectionActive .bg-dark-footer{
  background: transparent !important;
  color: #e2eecc !important;
}

.bg-dark-footer{
  background: rgb(33,37,41) !important;
  color: #ffe6c8 !important;
}


.studentSectionActive .bg-dark{
  background: #004c4c !important;
  color: #1c2933 !important;
}

.tutorsSectionActive  .bg-dark{
  background: #696969 !important;
  color: #1c2933;
}

.parentSectionActive .bg-dark-footer{
  background: transparent !important;
  color: #004c4c !important;
}

.corporationSectionActive .bg-dark-footer{
  background: transparent !important;
  color: #37678b !important;
}

.teacherSectionActive .bg-dark-footer{
  background: transparent !important;
  color: #e2eecc !important;
}

.administratorsSectionActive .bg-dark-footer{
  background: transparent !important;
  color: #7b3038 !important;
}

.tutorsSectionActive .bg-dark-footer{
  background: transparent !important;
  color: #ffe6c8 !important;
}

.corporationSectionActive .bg-dark{
  background: #87ceeb !important;
  color: #1c2933;
}

.teacherSectionActive .bg-dark{
  background: #456434 !important;
  color: #1c2933;
}

.administratorsSectionActive .bg-dark {
  background: #ff8789 !important;
  color: #1c2933;
}

.body-color-1{
  background-color: #c9e8f9;
  color: #37678b;
}
.body-color-p{
  background-color: #e2eecc !important;
  color: #004c4c;
}

.body-color-t{
  background-color: #7b3038 !important;
  color: #e2eecc;
}
.body-color-ad {
  background-color: #f6adb8;
  color:#7b3038;
}
.text-yellow {
  color: var(--bs-text-color) !important;
}

.text-lightgreen {
  color: var(--bs-light-green) !important;
}

.outline-lightgreen {
  border: 1px solid #ffe6c8 !important;
  color: #ffe6c8 !important;

}

.studentSectionActive .outline-lightgreen {
  border: 1px solid #e2eecc !important; 
}

.tutorsSectionActive .outline-lightgreen {
  border: 1px solid #ffe6c8 !important;
  color: #ffe6c8;

}

.administratorsSectionActive .outline-lightgreen {
  border: 1px solid #7b3038 !important;
  color: #7b3038;

}

.teacherSectionActive .outline-lightgreen{
  border: 1px solid #e2eecc !important;
  color: #e2eecc;

}

.corporationSectionActive .outline-lightgreen{
  border: 1px solid #37678b !important;
  color: #37678b;

}

.parentSectionActive .outline-lightgreen {
  border: 1px solid #004c4c !important;
  color: #004c4c;

}
/* ------------------ */

.braintrainingSectionActive .outline-lightgreen {
  border: 1px solid #e2eecc !important;
  color: #e2eecc;

}
.enhancedAiSectionActive .outline-lightgreen {
  border: 1px solid #e2eecc !important;
  
}

.neurofeedbackSectionActive .outline-lightgreen {
  border: 1px solid #004c4c !important;
}

.specialNeedsSectionActive .outline-lightgreen {
  border: 1px solid #37678b !important;
}

.cultureSectionActive .outline-lightgreen {
  border: 1px solid #7b3038 !important;
}

.managementsolutionsSectionActive .outline-lightgreen {
  border: 1px solid #ffe6c8 !important;
}

.aboutSectionActive .outline-lightgreen {
  border: 1px solid #ffe6c8 !important;
}

.about-top{
  padding-top: none;
}

.f-ui-1 {
  font-family: var(--sans);
  font-size: 1rem;
  line-height: 130%;
  letter-spacing: 0;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
}

.rotate-upwards {
  transform: rotate(180deg);
}

.Join {
  margin-left: 6vw !important;
}
.common-boxshadow {
  box-shadow: 0.1vw 0.1vw 0.2vw #808080 !important;
}

.common-textshadow {
  text-shadow: 0.01rem 0.01rem 0.01rem #808080 !important;
}

.custom-large-heading {
  font-family: 'Montserrat-medium' !important;
  font-size: 4.8vh;
  font-weight: 600 !important;
  font-style: normal !important;
}

.custom-extra-large-heading {
  font-family: 'Montserrat-medium' !important;
  font-size: 6.8vh !important;
  font-weight: 600 !important;
  font-style: normal !important;
}

.montser-lrg-heading-sml{
  font-family: 'Montserrat-large' !important;
  font-size: 5vh !important;
  font-weight: 600 !important;
  font-style: normal !important;
}

.montser-lrg {
  font-family: 'Montserrat-large' !important;
  font-size: 2.5vh !important;
  font-weight: 600 !important;
  font-style: normal !important;
}

.montser-MediumItalic{
  font-family: 'Montserrat-mdm-italic' !important;
  font-size: 4vh !important;
  font-weight: unset !important;
  font-style: italic!important;
}

.montser-ThinItalic{
  font-family: 'Montserrat-Thin-italic' !important;
  font-size: 4vh !important;
  font-weight: unset !important;
  font-style: italic!important;
}

.montser-LightItalic{
  font-family: 'Montserrat-Light-italic' !important;
  font-size: 4vh !important;
  font-weight: unset !important;
  font-style: italic!important;
}

.montser-sml-LightItalic{
  font-family: 'Montserrat-Light-italic' !important;
  font-size: 2vh ;
  font-weight: unset !important;
  font-style: italic!important;
}
.montser-sml-LightItalic-1rem{
  font-family: 'Montserrat-Light-italic' !important;
  font-size: 1rem ;
  font-weight: unset !important;
  font-style: italic!important;
}

.montser-lrg-LightItalic{
  font-family: 'Montserrat-Light-italic' !important;
  font-size: 5vh !important;
  font-weight: unset !important;
  font-style: italic!important;
}


.monster-lrg-italic-normal {
  font-family: 'Montserrat-large' !important;
  font-size: 2vh !important;
  font-weight:normal !important;
  font-style: italic !important;
}
.monster-mdm-italic-normal {
  font-family: 'Montserrat-medium' !important;
  font-size: 2vh !important;
  font-weight:normal !important;
  font-style: italic !important;
}

.montser-sml-italic {
  font-family: 'Montserrat-medium' !important;
  font-size: 0.8rem !important;
  font-weight: 600 !important;
  font-style: italic !important;
}

.montser-sml-bold {
  font-family: 'Montserrat-medium' !important;
  font-size: 2vh !important;
  font-weight: bold !important; /* Updated to bold */
  font-style: normal !important;
}

.montser-lrg-bold-re {
  font-family: 'Montserrat-large' !important;
  font-size: 2vh !important;
  font-weight: 600 !important;
  font-style: normal !important;
}
.montser-lrg-bold-0-8rem {
  font-family: 'Montserrat-large' !important;
  font-size: 0.8rem !important;
  font-weight: 600 !important;
  font-style: normal !important;
}

.monster-lrg-normal {
  font-family: 'Montserrat-medium' !important;
  font-size: 2vh !important;
  font-weight: normal !important;
  font-style: normal !important;
}

.montser-mdm-2 {
  font-family: 'Montserrat-medium' !important;
  font-size: 2vh !important;
  font-weight: 600 !important;
  font-style: normal !important;
}
.montser-mdm-1rem {
  font-family: 'Montserrat-medium' !important;
  font-size: 1rem;
  font-weight: 600 !important;
  font-style: normal !important;
}

.montser-mdm-italic{
  font-family: 'Montserrat-medium' !important;
  font-size: 2vh;
  font-weight: 600 !important;
  font-style: italic !important;
}

.montser-mdm {
  font-family: 'Montserrat-medium' !important;
  font-size: 2vh !important;
  font-style: normal !important;
  font-weight: normal !important;
}

.montser-sml {
  font-family: 'Montserrat-small' !important;
  font-size: 1.3vh !important;
  font-style: normal !important;
  font-weight: normal !important;
}


.montser-sml-italic {
  font-family: 'Montserrat-medium' !important;
  font-size: 2vh !important;
  font-weight: 600 !important;
  font-style: italic !important;
}

.montser-sml-bold {
  font-family: 'Montserrat-medium' !important;
  font-size: 2vh !important;
  font-weight: bold !important; /* Updated to bold */
  font-style: normal !important;
}

.montser-lrg-bold {
  font-family: 'Montserrat-large' !important;
  font-size: 2.5vh !important;
  font-weight: bolder !important;
  font-style: normal !important;
}

.monster-lrg-normal {
  font-family: 'Montserrat-medium' !important;
  font-size: 2vh !important;
  font-weight: 600 !important;
  font-style: normal !important;
}
.monster-lrg-italic {
  font-family: 'Montserrat-large' !important;
  font-size: 2.5vh !important;
  font-weight: normal;
  font-style: italic !important;
}
.ft-2-5vh{
  font-size: 2.5vh !important;
}
.ft-2-3vh{
  font-size: 1.2rem !important;
}
.ft-1{
  font-size: 2rem !important;
}
.ft-3vh{
  font-size: 3vh !important;
}

.ft-section-heading {
  font-size: 3vh !important;
}

.ft-4vh{
  font-size: 4vh !important;
}

.ft-5vh{
  font-size: 5vh;
}

.ft-6vh{
  font-size: 6vh !important;
}

.gap-7{
  gap: 5rem!important;
}

.card:hover .scroll-text {
  text-decoration: underline;
  text-underline-offset: 0.5vh;
}

.dropdown-item-effect {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
  padding-left: 0 !important;
}

.pdl-1vw {
  padding-left: 1vw !important;
}

.text-decorator-underline:hover {
  text-decoration: underline !important;
  text-underline-offset: 0.5vh;
}

.align-center {
  align-items: center !important;
}

.justify-content-center {
  justify-content: center !important;
}

.nav-context-menu-title {
  padding-right: 0 !important;
  padding-left: 0 !important
}

.arrow-icon-top {
  margin-left: 0.5vw !important;
}
.ptb-4rem{
  padding: 7rem 0 !important;
}
.mt-8rem{
  margin-top: 8rem !important;
}
.pt-4rem{
  padding-top: 4rem !important;
}
.vp-container {
  width: 100%;
  margin: 0 auto;
  padding: 0 !important;
  left: 0;
}

.ht-10vh{
  height: 10vh !important;
}
.rotated-icon {
  transform: rotate(45deg);
}

.drop-down-icon {
  margin-left: 0.5vw;
  width: 10px;
  /* Adjust the size as needed */
  height: 10px;
  /* Adjust the size as needed */
}

.video-button {
  box-shadow: 1px 1px #808080 !important;
}


.siteLogo img {
  transform-style: preserve-3d;
  transform: rotateY(0deg);
  animation: animate 18s linear infinite;
  max-width: 50px;
  width: 100%;
  height: 100%;
  max-height: 32px;
}
.footer-container .siteLogo img{
  /* margin-top: 2.5rem !important; */
  margin-bottom: -0.2rem !important;
}

@keyframes animate {
  to {
    transform: rotateY(-360deg);
  }
}


.nav-item button:hover span {
  color: #1c2933 !important;
  background-color: #fee6c8;
}


.nav-item button {
  /* color: #ffe6c8; */
  height: 4vh !important;
  line-height: initial;
  /* border: 1px solid white !important; */
 
}
.about button{
  height: 3rem !important;
  width: 15rem !important;
}

.headings {
  height: 91px;
  justify-content: end;
}

.pt-1-5rem{

  padding-top: 1.5rem !important
}
.footer-padding {
  padding-top: 1rem !important;
  padding-bottom: 2rem !important;
}
/* .about button:hover {
  color: #1c2933 !important;
  background-color: #ffe6c8;

} */

.join button:hover {
  color: #1c2933;
  background-color: #ffe6c8;
}


.shadowsSectionActive .join button:hover {
  background-color: #7b3038 !important;
  color: #f6adb8 !important;
}

.shadowsSectionActive .nav-item button:hover span {
  background-color: #7b3038 !important;
  color: #f6adb8 !important;
}

.educationSectionActive .join button:hover {
  background-color: #37678b !important;
  color: #c9e8f9 !important;
}

.educationSectionActive .nav-item button:hover span {
  background-color: #37678b !important;
  color: #c9e8f9 !important;
}

.repetitionSectionActive .join button:hover {
  background-color: #e2eecc !important;
  color: #004c4c !important;
}

.repetitionSectionActive .nav-item button:hover span {
  background-color: #e2eecc !important;
  color: #004c4c !important;
}

.shadowsSectionActive .join button:hover {
  background-color: #7b3038 !important;
  color: #f6adb8 !important;
}

.shadowsSectionActive .nav-item button:hover span {
  background-color: #7b3038 !important;
  color: #f6adb8 !important;
}

.kaleidoscopeSectionActive .join button:hover {
  background-color: #7b3038 !important;
  color: #7b3038 !important;
}

.kaleidoscopeSectionActive .nav-item button:hover span {
  background-color: #7b3038 !important;
  color: #f6adb8 !important;
} 

.matrixSectionActive .join button:hover {
  background-color: #e2eecc !important;
  color: #7b3038 !important;
}

.matrixSectionActive .nav-item button:hover span {
  background-color: #e2eecc !important;
  color: #7b3038 !important;
}

.neuroSectionActive .join button:hover {
  background-color: #004c4c !important;
  color: #e2eecc !important;
}

.neuroSectionActive .nav-item button:hover span {
  background-color: #004c4c !important;
  color: #e2eecc !important;
}

.footer-container {  
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  /* width: 100%; */
  padding-right: calc(var(--bs-gutter-x) * .5);
  padding-left: calc(var(--bs-gutter-x) * .5);
  /* margin-right: auto; */
  /* margin-left: 4%; */
}

.img-contain {
  max-height: 100vh;
  height: 100%;
  object-fit: contain;
}

.student-wide-img {
  width: 100% !important;
  object-fit: cover;
}

.bg-light span,.sectionActive .bg-dark-footer span,.sectionActive .bg-dark-footer i,
.bg-light i {
  color: #1c2933 !important;
}

.student-top-padding {
  padding-top: 10%;
}

.student-section-padding {
  padding-top: 5vw;
}

.footer-navbar-brand {
  padding-bottom: 1rem;
  font-size: 1.25rem;
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}

.align-left {
  margin-left: 7px !important;
}

.hide-scrolbar {
  overflow-x: hidden;
}

.footer-icon-margin {
  width: 40px;
}

/* .header-txt-margin {
  margin-left: 4vw !important;
  padding-left: 8vw !important;
} */

.header-txt-img-text {
  margin-left: 1vw !important;
}
/* Add this to your stylesheet */
.rotate {
  transform: rotate(180deg);
  /* Adjust the rotation degree as needed */
  transition: transform 0.3s ease;
  /* Add a smooth transition effect */
}

.student-top-margin {
  margin-top: 10%;
}


.student-top-position {
  position: relative;
  top: 87px;
}



.stud-head-bg {
  background-color: #efefef;
  color: #333333;
}



.navbar-expand-lg .navbar-nav .nav-link{
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.footer-head-p{
  padding-right: 1rem !important;
}


/* common classes  */

.z-index-9 {
  z-index: 9;
}

.maxw-265 {
  max-width: 265px;
  min-width: 265px;
}

.maxw-450 {
  max-width: 450px;
}

.maxw-650 {
  max-width: 450px;
}


.text-virtu-header, .icon-site-logo-  {
  color: #ffe6c8 !important;
}


.body-color-4{
  color: #ffe6c8;
  background: #333333;
}

/* student page */ 

.section-img {
  max-height: 530px;
  max-width: 530px !important;
}



.blog-body-color{
  background-color: #efefef;
  color: #333333;
}

.back-to-top {
  display: flex;
  justify-content: end;
}

.side-bottom {
  width: 2.2vw;
    height: 1.2vw;
    display: inline-block;
    background-position: center!important;
}


.footer button:hover span {  
    color: #1c2933 !important;
    background-color: #efefef !important;
}

/* _________________blogs ________________ */

.content-margin {
  margin-left: 9vw !important;
  margin-right: 9vw !important;
  padding-bottom: 5rem !important;
}


/* -------colour-------- */

.bg-body-tutor {
  background-color: #e2eecc !important;
  color: #004c4c !important;
}


.bg-body-neuro {
  background-color: #e2eecc !important;
  color: #004c4c !important;
}

.bg-body-education {
  background-color: #c9e8f9;
  color: #37678b; 
}

.bg-body-kaleidoscope {
  background-color: #f6adb8;
  color:#7b3038;
}

.bg-body-matrix{
  background-color: #7b3038 !important;
  color: #e2eecc; 
}

.bg-body-neuroscience {
  color: #ffe6c8;
  background: #333333;
}

.bg-body-repetition{
  background-color: var(--bs-bg-body) !important;
  color: var(--bs-text-body) !important;
}

.bg-body-shadows {
background-color: #f6adb8;
color:#7b3038;
}

/* -----navbar------ */



/* --------------- */

/* --------------- */


/* --------------- */




/* --------------- */




/* --------------- */


/* --------------- */

/* --------------- */


.blogdashSectionActive .text-yellow {
color: #e2eecc  !important;
} 

.blogdashSectionActive .bg-dark-footer{
background: transparent !important;
color: #e2eecc  !important;
}

.rotateIcon {
  display: inline-block;
  transform-origin: center center;
  animation: rotateY 15s linear infinite alternate; 
}

@keyframes rotateY {
  to {
    transform: rotateY(-360deg);
  }
}

.icon-checkiconsolid {
  font-size: 40px !important;
  font-weight: 900;
  color: #80B06D;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}
.icon-site-logo-{
  font-size: 4vh;
}
.montser-lrg, .reg-montser-lrg {
  font-family: 'Montserrat-large' !important;
  font-size: 1vw !important;
  font-weight: 100 !important;
  font-style: normal !important;
}
/* Default layout for larger screens */
.job-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
}

/* Ensure equal left-right margins */
.job-card {
  width: 90%; /* Adjust this to control margin size */
  margin-left: auto;
  margin-right: auto;
}

/* Center icon on larger screens (non-mobile) */
.icon-container {
  margin-left: 10px;
}

/* Media query for screens with a max-width of 575px (mobile) */
@media (max-width: 575px) {
  .job-container {
    flex-direction: column; /* Stack content vertically */
    align-items: center; /* Center both description and icon */
    text-align: center; /* Center-align text */
  }

  .icon-container {
    margin-top: 10px; /* Add spacing between description and icon */
    align-self: center; /* Center the icon below description */
  }

  .job-card {
    width: 100%; /* Take full width on mobile */
    padding-left: 10vw !important;
    padding-right: 10vw !important;
  }

  .container-fluid{
    padding-left: 5vw !important;
    padding-right: 5vw !important;
   
  }
}

/* Center align heading */
.section-heading {
  text-align: center;
  margin-bottom: 1rem;
  font-size: 2rem;
  font-weight: bold;
}

/* Left align paragraphs */
.paragraph-text {
  text-align: left;
  font-size: 1.2rem !important;
  line-height: 1.6;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .section-heading {
    font-size: 1.5rem; /* Smaller heading on tablets */
  }
  .paragraph-text {
    font-size: 0.9rem; /* Slightly smaller paragraphs on mobile */
  }
}

@media (max-width: 576px) {
  .section-heading {
    font-size: 1.3rem; /* Smaller heading on mobile */
  }
  .paragraph-text {
    font-size: 0.8rem; /* Smaller paragraphs on very small screens */
  }
  .v-about {
    display: none !important;
  }
  
  .navbar-nav{
    margin-top: 1rem !important;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
      padding-left: 1.5rem !important;
      padding-right: 1.5rem !important;
  }

  .mainSectionDiv .container-fluid,.footer-padding{
    padding-left: 2rem;
    padding-right:2rem;
  }
  .btn-md{
    width:15rem !important;
  }
  .v-about button{
    height: 3rem !important;
    width: 15rem !important;
    background: #ffe6c8;
    color: #1c2933 !important;
  }
  
}
.navbar-hidden {
  transform: translateY(-100%);
  transition: transform 0.3s ease-in-out;
}

.v-about button{
  background: #ffe6c8 !important;
  color: #1c2933 !important;
}
.v-about button:hover{
  background:#1c2933 !important;
  color: #ffe6c8 !important;
}

`, "",{"version":3,"sources":["webpack://./src/global.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,8CAA8C;EAC9C,qCAAqC;AACvC;;;;AAIA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;AAC1B;;;AAGA;EACE,kCAAkC;;AAEpC;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;;AAGA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;;AAE3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,cAAc;;AAEhB;;AAEA;EACE,oCAAoC;EACpC,cAAc;;AAEhB;;AAEA;EACE,oCAAoC;EACpC,cAAc;;AAEhB;;AAEA;EACE,oCAAoC;EACpC,cAAc;;AAEhB;;AAEA;EACE,oCAAoC;EACpC,cAAc;;AAEhB;AACA,uBAAuB;;AAEvB;EACE,oCAAoC;EACpC,cAAc;;AAEhB;AACA;EACE,oCAAoC;;AAEtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,gDAAgD;AAClD;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;EAChB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,gDAAgD;EAChD,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,iDAAiD;EACjD,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,iDAAiD;EACjD,eAAe;EACf,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,iDAAiD;EACjD,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;AAC9B;;;AAGA;EACE,0CAA0C;EAC1C,yBAAyB;EACzB,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,2CAA2C;EAC3C,yBAAyB;EACzB,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,2CAA2C;EAC3C,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,2CAA2C;EAC3C,yBAAyB;EACzB,4BAA4B,EAAE,oBAAoB;EAClD,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,0CAA0C;EAC1C,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,2CAA2C;EAC3C,yBAAyB;EACzB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,2CAA2C;EAC3C,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,2CAA2C;EAC3C,eAAe;EACf,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,2CAA2C;EAC3C,cAAc;EACd,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,2CAA2C;EAC3C,yBAAyB;EACzB,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;AAChC;;;AAGA;EACE,2CAA2C;EAC3C,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,2CAA2C;EAC3C,yBAAyB;EACzB,4BAA4B,EAAE,oBAAoB;EAClD,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,2CAA2C;EAC3C,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,4EAA4E;EAC5E,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;EACT,uDAAuD;EACvD,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B;AACF;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,cAAc;EACd,qBAAqB;EACrB,OAAO;AACT;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;AACxC;;;AAGA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,sCAAsC;EACtC,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;;AAGA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;;AAGA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;EACpB,wCAAwC;;AAE1C;AACA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;EAEE;AACF;AACA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;;;;GAIG;;AAEH;EACE,cAAc;EACd,yBAAyB;AAC3B;;;AAGA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;EAC5C,2CAA2C;EAC3C,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,mCAAmC;EACnC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;;;GAGG;;AAEH;EACE,2BAA2B;AAC7B;AACA,gCAAgC;AAChC;EACE,yBAAyB;EACzB,yCAAyC;EACzC,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,kBAAkB;EAClB,SAAS;AACX;;;;AAIA;EACE,yBAAyB;EACzB,cAAc;AAChB;;;;AAIA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;;AAGA,oBAAoB;;AAEpB;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,iBAAiB;;AAEjB;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;;;AAIA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,YAAY;IACV,aAAa;IACb,qBAAqB;IACrB,qCAAqC;AACzC;;;AAGA;IACI,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA,4CAA4C;;AAE5C;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,+BAA+B;AACjC;;;AAGA,0BAA0B;;AAE1B;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;;AAGA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;EAC9C,qCAAqC;AACvC;;AAEA;AACA,yBAAyB;AACzB,aAAa;AACb;;AAEA,sBAAsB;;;;AAItB,oBAAoB;;AAEpB,oBAAoB;;;AAGpB,oBAAoB;;;;;AAKpB,oBAAoB;;;;;AAKpB,oBAAoB;;;AAGpB,oBAAoB;;AAEpB,oBAAoB;;;AAGpB;AACA,0BAA0B;AAC1B;;AAEA;AACA,kCAAkC;AAClC,0BAA0B;AAC1B;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,gDAAgD;AAClD;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,cAAc;AAChB;AACA;EACE,0CAA0C;EAC1C,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA,sCAAsC;AACtC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,UAAU,EAAE,uCAAuC;EACnD,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE,iBAAiB;AACnB;;AAEA,+DAA+D;AAC/D;EACE;IACE,sBAAsB,EAAE,6BAA6B;IACrD,mBAAmB,EAAE,qCAAqC;IAC1D,kBAAkB,EAAE,sBAAsB;EAC5C;;EAEA;IACE,gBAAgB,EAAE,6CAA6C;IAC/D,kBAAkB,EAAE,sCAAsC;EAC5D;;EAEA;IACE,WAAW,EAAE,8BAA8B;IAC3C,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;;EAE/B;AACF;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE;IACE,iBAAiB,EAAE,+BAA+B;EACpD;EACA;IACE,iBAAiB,EAAE,0CAA0C;EAC/D;AACF;;AAEA;EACE;IACE,iBAAiB,EAAE,8BAA8B;EACnD;EACA;IACE,iBAAiB,EAAE,6CAA6C;EAClE;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;MACI,+BAA+B;MAC/B,gCAAgC;EACpC;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;EAC3B;;AAEF;AACA;EACE,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B","sourcesContent":[":root {\r\n  --bs-text-color: #ffe6c8;\r\n  --bs-light-green: #d5dec1;\r\n  --bs-bg-dark: black ;\r\n  --bs-bg-body: #008080;\r\n  --bs-text-body: #e2eecc;\r\n}\r\n\r\n.bg-primarycolor {\r\n  background-color: var(--bs-bg-body) !important;\r\n  color: var(--bs-text-body) !important;\r\n}\r\n\r\n\r\n\r\n.bg-dark {\r\n  background: black !important;\r\n}\r\n\r\n.bg-black {\r\n  background: black !important;\r\n  color:#ffe6c8 !important;\r\n}\r\n\r\n\r\n.bg-tranparent{\r\n  background: transparent !important;\r\n\r\n}\r\n.light-col{\r\n  color: #ffe6c8!important; \r\n}\r\n\r\n.studentSectionActive .bg-dark-footer{\r\n  background: transparent !important;\r\n  color: #e2eecc !important;\r\n}\r\n\r\n.bg-dark-footer{\r\n  background: rgb(33,37,41) !important;\r\n  color: #ffe6c8 !important;\r\n}\r\n\r\n\r\n.studentSectionActive .bg-dark{\r\n  background: #004c4c !important;\r\n  color: #1c2933 !important;\r\n}\r\n\r\n.tutorsSectionActive  .bg-dark{\r\n  background: #696969 !important;\r\n  color: #1c2933;\r\n}\r\n\r\n.parentSectionActive .bg-dark-footer{\r\n  background: transparent !important;\r\n  color: #004c4c !important;\r\n}\r\n\r\n.corporationSectionActive .bg-dark-footer{\r\n  background: transparent !important;\r\n  color: #37678b !important;\r\n}\r\n\r\n.teacherSectionActive .bg-dark-footer{\r\n  background: transparent !important;\r\n  color: #e2eecc !important;\r\n}\r\n\r\n.administratorsSectionActive .bg-dark-footer{\r\n  background: transparent !important;\r\n  color: #7b3038 !important;\r\n}\r\n\r\n.tutorsSectionActive .bg-dark-footer{\r\n  background: transparent !important;\r\n  color: #ffe6c8 !important;\r\n}\r\n\r\n.corporationSectionActive .bg-dark{\r\n  background: #87ceeb !important;\r\n  color: #1c2933;\r\n}\r\n\r\n.teacherSectionActive .bg-dark{\r\n  background: #456434 !important;\r\n  color: #1c2933;\r\n}\r\n\r\n.administratorsSectionActive .bg-dark {\r\n  background: #ff8789 !important;\r\n  color: #1c2933;\r\n}\r\n\r\n.body-color-1{\r\n  background-color: #c9e8f9;\r\n  color: #37678b;\r\n}\r\n.body-color-p{\r\n  background-color: #e2eecc !important;\r\n  color: #004c4c;\r\n}\r\n\r\n.body-color-t{\r\n  background-color: #7b3038 !important;\r\n  color: #e2eecc;\r\n}\r\n.body-color-ad {\r\n  background-color: #f6adb8;\r\n  color:#7b3038;\r\n}\r\n.text-yellow {\r\n  color: var(--bs-text-color) !important;\r\n}\r\n\r\n.text-lightgreen {\r\n  color: var(--bs-light-green) !important;\r\n}\r\n\r\n.outline-lightgreen {\r\n  border: 1px solid #ffe6c8 !important;\r\n  color: #ffe6c8 !important;\r\n\r\n}\r\n\r\n.studentSectionActive .outline-lightgreen {\r\n  border: 1px solid #e2eecc !important; \r\n}\r\n\r\n.tutorsSectionActive .outline-lightgreen {\r\n  border: 1px solid #ffe6c8 !important;\r\n  color: #ffe6c8;\r\n\r\n}\r\n\r\n.administratorsSectionActive .outline-lightgreen {\r\n  border: 1px solid #7b3038 !important;\r\n  color: #7b3038;\r\n\r\n}\r\n\r\n.teacherSectionActive .outline-lightgreen{\r\n  border: 1px solid #e2eecc !important;\r\n  color: #e2eecc;\r\n\r\n}\r\n\r\n.corporationSectionActive .outline-lightgreen{\r\n  border: 1px solid #37678b !important;\r\n  color: #37678b;\r\n\r\n}\r\n\r\n.parentSectionActive .outline-lightgreen {\r\n  border: 1px solid #004c4c !important;\r\n  color: #004c4c;\r\n\r\n}\r\n/* ------------------ */\r\n\r\n.braintrainingSectionActive .outline-lightgreen {\r\n  border: 1px solid #e2eecc !important;\r\n  color: #e2eecc;\r\n\r\n}\r\n.enhancedAiSectionActive .outline-lightgreen {\r\n  border: 1px solid #e2eecc !important;\r\n  \r\n}\r\n\r\n.neurofeedbackSectionActive .outline-lightgreen {\r\n  border: 1px solid #004c4c !important;\r\n}\r\n\r\n.specialNeedsSectionActive .outline-lightgreen {\r\n  border: 1px solid #37678b !important;\r\n}\r\n\r\n.cultureSectionActive .outline-lightgreen {\r\n  border: 1px solid #7b3038 !important;\r\n}\r\n\r\n.managementsolutionsSectionActive .outline-lightgreen {\r\n  border: 1px solid #ffe6c8 !important;\r\n}\r\n\r\n.aboutSectionActive .outline-lightgreen {\r\n  border: 1px solid #ffe6c8 !important;\r\n}\r\n\r\n.about-top{\r\n  padding-top: none;\r\n}\r\n\r\n.f-ui-1 {\r\n  font-family: var(--sans);\r\n  font-size: 1rem;\r\n  line-height: 130%;\r\n  letter-spacing: 0;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  -webkit-font-smoothing: antialiased;\r\n}\r\n\r\n.rotate-upwards {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.Join {\r\n  margin-left: 6vw !important;\r\n}\r\n.common-boxshadow {\r\n  box-shadow: 0.1vw 0.1vw 0.2vw #808080 !important;\r\n}\r\n\r\n.common-textshadow {\r\n  text-shadow: 0.01rem 0.01rem 0.01rem #808080 !important;\r\n}\r\n\r\n.custom-large-heading {\r\n  font-family: 'Montserrat-medium' !important;\r\n  font-size: 4.8vh;\r\n  font-weight: 600 !important;\r\n  font-style: normal !important;\r\n}\r\n\r\n.custom-extra-large-heading {\r\n  font-family: 'Montserrat-medium' !important;\r\n  font-size: 6.8vh !important;\r\n  font-weight: 600 !important;\r\n  font-style: normal !important;\r\n}\r\n\r\n.montser-lrg-heading-sml{\r\n  font-family: 'Montserrat-large' !important;\r\n  font-size: 5vh !important;\r\n  font-weight: 600 !important;\r\n  font-style: normal !important;\r\n}\r\n\r\n.montser-lrg {\r\n  font-family: 'Montserrat-large' !important;\r\n  font-size: 2.5vh !important;\r\n  font-weight: 600 !important;\r\n  font-style: normal !important;\r\n}\r\n\r\n.montser-MediumItalic{\r\n  font-family: 'Montserrat-mdm-italic' !important;\r\n  font-size: 4vh !important;\r\n  font-weight: unset !important;\r\n  font-style: italic!important;\r\n}\r\n\r\n.montser-ThinItalic{\r\n  font-family: 'Montserrat-Thin-italic' !important;\r\n  font-size: 4vh !important;\r\n  font-weight: unset !important;\r\n  font-style: italic!important;\r\n}\r\n\r\n.montser-LightItalic{\r\n  font-family: 'Montserrat-Light-italic' !important;\r\n  font-size: 4vh !important;\r\n  font-weight: unset !important;\r\n  font-style: italic!important;\r\n}\r\n\r\n.montser-sml-LightItalic{\r\n  font-family: 'Montserrat-Light-italic' !important;\r\n  font-size: 2vh ;\r\n  font-weight: unset !important;\r\n  font-style: italic!important;\r\n}\r\n.montser-sml-LightItalic-1rem{\r\n  font-family: 'Montserrat-Light-italic' !important;\r\n  font-size: 1rem ;\r\n  font-weight: unset !important;\r\n  font-style: italic!important;\r\n}\r\n\r\n.montser-lrg-LightItalic{\r\n  font-family: 'Montserrat-Light-italic' !important;\r\n  font-size: 5vh !important;\r\n  font-weight: unset !important;\r\n  font-style: italic!important;\r\n}\r\n\r\n\r\n.monster-lrg-italic-normal {\r\n  font-family: 'Montserrat-large' !important;\r\n  font-size: 2vh !important;\r\n  font-weight:normal !important;\r\n  font-style: italic !important;\r\n}\r\n.monster-mdm-italic-normal {\r\n  font-family: 'Montserrat-medium' !important;\r\n  font-size: 2vh !important;\r\n  font-weight:normal !important;\r\n  font-style: italic !important;\r\n}\r\n\r\n.montser-sml-italic {\r\n  font-family: 'Montserrat-medium' !important;\r\n  font-size: 0.8rem !important;\r\n  font-weight: 600 !important;\r\n  font-style: italic !important;\r\n}\r\n\r\n.montser-sml-bold {\r\n  font-family: 'Montserrat-medium' !important;\r\n  font-size: 2vh !important;\r\n  font-weight: bold !important; /* Updated to bold */\r\n  font-style: normal !important;\r\n}\r\n\r\n.montser-lrg-bold-re {\r\n  font-family: 'Montserrat-large' !important;\r\n  font-size: 2vh !important;\r\n  font-weight: 600 !important;\r\n  font-style: normal !important;\r\n}\r\n.montser-lrg-bold-0-8rem {\r\n  font-family: 'Montserrat-large' !important;\r\n  font-size: 0.8rem !important;\r\n  font-weight: 600 !important;\r\n  font-style: normal !important;\r\n}\r\n\r\n.monster-lrg-normal {\r\n  font-family: 'Montserrat-medium' !important;\r\n  font-size: 2vh !important;\r\n  font-weight: normal !important;\r\n  font-style: normal !important;\r\n}\r\n\r\n.montser-mdm-2 {\r\n  font-family: 'Montserrat-medium' !important;\r\n  font-size: 2vh !important;\r\n  font-weight: 600 !important;\r\n  font-style: normal !important;\r\n}\r\n.montser-mdm-1rem {\r\n  font-family: 'Montserrat-medium' !important;\r\n  font-size: 1rem;\r\n  font-weight: 600 !important;\r\n  font-style: normal !important;\r\n}\r\n\r\n.montser-mdm-italic{\r\n  font-family: 'Montserrat-medium' !important;\r\n  font-size: 2vh;\r\n  font-weight: 600 !important;\r\n  font-style: italic !important;\r\n}\r\n\r\n.montser-mdm {\r\n  font-family: 'Montserrat-medium' !important;\r\n  font-size: 2vh !important;\r\n  font-style: normal !important;\r\n  font-weight: normal !important;\r\n}\r\n\r\n.montser-sml {\r\n  font-family: 'Montserrat-small' !important;\r\n  font-size: 1.3vh !important;\r\n  font-style: normal !important;\r\n  font-weight: normal !important;\r\n}\r\n\r\n\r\n.montser-sml-italic {\r\n  font-family: 'Montserrat-medium' !important;\r\n  font-size: 2vh !important;\r\n  font-weight: 600 !important;\r\n  font-style: italic !important;\r\n}\r\n\r\n.montser-sml-bold {\r\n  font-family: 'Montserrat-medium' !important;\r\n  font-size: 2vh !important;\r\n  font-weight: bold !important; /* Updated to bold */\r\n  font-style: normal !important;\r\n}\r\n\r\n.montser-lrg-bold {\r\n  font-family: 'Montserrat-large' !important;\r\n  font-size: 2.5vh !important;\r\n  font-weight: bolder !important;\r\n  font-style: normal !important;\r\n}\r\n\r\n.monster-lrg-normal {\r\n  font-family: 'Montserrat-medium' !important;\r\n  font-size: 2vh !important;\r\n  font-weight: 600 !important;\r\n  font-style: normal !important;\r\n}\r\n.monster-lrg-italic {\r\n  font-family: 'Montserrat-large' !important;\r\n  font-size: 2.5vh !important;\r\n  font-weight: normal;\r\n  font-style: italic !important;\r\n}\r\n.ft-2-5vh{\r\n  font-size: 2.5vh !important;\r\n}\r\n.ft-2-3vh{\r\n  font-size: 1.2rem !important;\r\n}\r\n.ft-1{\r\n  font-size: 2rem !important;\r\n}\r\n.ft-3vh{\r\n  font-size: 3vh !important;\r\n}\r\n\r\n.ft-section-heading {\r\n  font-size: 3vh !important;\r\n}\r\n\r\n.ft-4vh{\r\n  font-size: 4vh !important;\r\n}\r\n\r\n.ft-5vh{\r\n  font-size: 5vh;\r\n}\r\n\r\n.ft-6vh{\r\n  font-size: 6vh !important;\r\n}\r\n\r\n.gap-7{\r\n  gap: 5rem!important;\r\n}\r\n\r\n.card:hover .scroll-text {\r\n  text-decoration: underline;\r\n  text-underline-offset: 0.5vh;\r\n}\r\n\r\n.dropdown-item-effect {\r\n  display: block;\r\n  width: 100%;\r\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\r\n  clear: both;\r\n  font-weight: 400;\r\n  color: var(--bs-dropdown-link-color);\r\n  text-align: inherit;\r\n  text-decoration: none;\r\n  white-space: nowrap;\r\n  background-color: transparent;\r\n  border: 0;\r\n  border-radius: var(--bs-dropdown-item-border-radius, 0);\r\n  padding-left: 0 !important;\r\n}\r\n\r\n.pdl-1vw {\r\n  padding-left: 1vw !important;\r\n}\r\n\r\n.text-decorator-underline:hover {\r\n  text-decoration: underline !important;\r\n  text-underline-offset: 0.5vh;\r\n}\r\n\r\n.align-center {\r\n  align-items: center !important;\r\n}\r\n\r\n.justify-content-center {\r\n  justify-content: center !important;\r\n}\r\n\r\n.nav-context-menu-title {\r\n  padding-right: 0 !important;\r\n  padding-left: 0 !important\r\n}\r\n\r\n.arrow-icon-top {\r\n  margin-left: 0.5vw !important;\r\n}\r\n.ptb-4rem{\r\n  padding: 7rem 0 !important;\r\n}\r\n.mt-8rem{\r\n  margin-top: 8rem !important;\r\n}\r\n.pt-4rem{\r\n  padding-top: 4rem !important;\r\n}\r\n.vp-container {\r\n  width: 100%;\r\n  margin: 0 auto;\r\n  padding: 0 !important;\r\n  left: 0;\r\n}\r\n\r\n.ht-10vh{\r\n  height: 10vh !important;\r\n}\r\n.rotated-icon {\r\n  transform: rotate(45deg);\r\n}\r\n\r\n.drop-down-icon {\r\n  margin-left: 0.5vw;\r\n  width: 10px;\r\n  /* Adjust the size as needed */\r\n  height: 10px;\r\n  /* Adjust the size as needed */\r\n}\r\n\r\n.video-button {\r\n  box-shadow: 1px 1px #808080 !important;\r\n}\r\n\r\n\r\n.siteLogo img {\r\n  transform-style: preserve-3d;\r\n  transform: rotateY(0deg);\r\n  animation: animate 18s linear infinite;\r\n  max-width: 50px;\r\n  width: 100%;\r\n  height: 100%;\r\n  max-height: 32px;\r\n}\r\n.footer-container .siteLogo img{\r\n  /* margin-top: 2.5rem !important; */\r\n  margin-bottom: -0.2rem !important;\r\n}\r\n\r\n@keyframes animate {\r\n  to {\r\n    transform: rotateY(-360deg);\r\n  }\r\n}\r\n\r\n\r\n.nav-item button:hover span {\r\n  color: #1c2933 !important;\r\n  background-color: #fee6c8;\r\n}\r\n\r\n\r\n.nav-item button {\r\n  /* color: #ffe6c8; */\r\n  height: 4vh !important;\r\n  line-height: initial;\r\n  /* border: 1px solid white !important; */\r\n \r\n}\r\n.about button{\r\n  height: 3rem !important;\r\n  width: 15rem !important;\r\n}\r\n\r\n.headings {\r\n  height: 91px;\r\n  justify-content: end;\r\n}\r\n\r\n.pt-1-5rem{\r\n\r\n  padding-top: 1.5rem !important\r\n}\r\n.footer-padding {\r\n  padding-top: 1rem !important;\r\n  padding-bottom: 2rem !important;\r\n}\r\n/* .about button:hover {\r\n  color: #1c2933 !important;\r\n  background-color: #ffe6c8;\r\n\r\n} */\r\n\r\n.join button:hover {\r\n  color: #1c2933;\r\n  background-color: #ffe6c8;\r\n}\r\n\r\n\r\n.shadowsSectionActive .join button:hover {\r\n  background-color: #7b3038 !important;\r\n  color: #f6adb8 !important;\r\n}\r\n\r\n.shadowsSectionActive .nav-item button:hover span {\r\n  background-color: #7b3038 !important;\r\n  color: #f6adb8 !important;\r\n}\r\n\r\n.educationSectionActive .join button:hover {\r\n  background-color: #37678b !important;\r\n  color: #c9e8f9 !important;\r\n}\r\n\r\n.educationSectionActive .nav-item button:hover span {\r\n  background-color: #37678b !important;\r\n  color: #c9e8f9 !important;\r\n}\r\n\r\n.repetitionSectionActive .join button:hover {\r\n  background-color: #e2eecc !important;\r\n  color: #004c4c !important;\r\n}\r\n\r\n.repetitionSectionActive .nav-item button:hover span {\r\n  background-color: #e2eecc !important;\r\n  color: #004c4c !important;\r\n}\r\n\r\n.shadowsSectionActive .join button:hover {\r\n  background-color: #7b3038 !important;\r\n  color: #f6adb8 !important;\r\n}\r\n\r\n.shadowsSectionActive .nav-item button:hover span {\r\n  background-color: #7b3038 !important;\r\n  color: #f6adb8 !important;\r\n}\r\n\r\n.kaleidoscopeSectionActive .join button:hover {\r\n  background-color: #7b3038 !important;\r\n  color: #7b3038 !important;\r\n}\r\n\r\n.kaleidoscopeSectionActive .nav-item button:hover span {\r\n  background-color: #7b3038 !important;\r\n  color: #f6adb8 !important;\r\n} \r\n\r\n.matrixSectionActive .join button:hover {\r\n  background-color: #e2eecc !important;\r\n  color: #7b3038 !important;\r\n}\r\n\r\n.matrixSectionActive .nav-item button:hover span {\r\n  background-color: #e2eecc !important;\r\n  color: #7b3038 !important;\r\n}\r\n\r\n.neuroSectionActive .join button:hover {\r\n  background-color: #004c4c !important;\r\n  color: #e2eecc !important;\r\n}\r\n\r\n.neuroSectionActive .nav-item button:hover span {\r\n  background-color: #004c4c !important;\r\n  color: #e2eecc !important;\r\n}\r\n\r\n.footer-container {  \r\n  --bs-gutter-x: 1.5rem;\r\n  --bs-gutter-y: 0;\r\n  /* width: 100%; */\r\n  padding-right: calc(var(--bs-gutter-x) * .5);\r\n  padding-left: calc(var(--bs-gutter-x) * .5);\r\n  /* margin-right: auto; */\r\n  /* margin-left: 4%; */\r\n}\r\n\r\n.img-contain {\r\n  max-height: 100vh;\r\n  height: 100%;\r\n  object-fit: contain;\r\n}\r\n\r\n.student-wide-img {\r\n  width: 100% !important;\r\n  object-fit: cover;\r\n}\r\n\r\n.bg-light span,.sectionActive .bg-dark-footer span,.sectionActive .bg-dark-footer i,\r\n.bg-light i {\r\n  color: #1c2933 !important;\r\n}\r\n\r\n.student-top-padding {\r\n  padding-top: 10%;\r\n}\r\n\r\n.student-section-padding {\r\n  padding-top: 5vw;\r\n}\r\n\r\n.footer-navbar-brand {\r\n  padding-bottom: 1rem;\r\n  font-size: 1.25rem;\r\n  color: var(--bs-navbar-brand-color);\r\n  text-decoration: none;\r\n  white-space: nowrap;\r\n}\r\n\r\n.align-left {\r\n  margin-left: 7px !important;\r\n}\r\n\r\n.hide-scrolbar {\r\n  overflow-x: hidden;\r\n}\r\n\r\n.footer-icon-margin {\r\n  width: 40px;\r\n}\r\n\r\n/* .header-txt-margin {\r\n  margin-left: 4vw !important;\r\n  padding-left: 8vw !important;\r\n} */\r\n\r\n.header-txt-img-text {\r\n  margin-left: 1vw !important;\r\n}\r\n/* Add this to your stylesheet */\r\n.rotate {\r\n  transform: rotate(180deg);\r\n  /* Adjust the rotation degree as needed */\r\n  transition: transform 0.3s ease;\r\n  /* Add a smooth transition effect */\r\n}\r\n\r\n.student-top-margin {\r\n  margin-top: 10%;\r\n}\r\n\r\n\r\n.student-top-position {\r\n  position: relative;\r\n  top: 87px;\r\n}\r\n\r\n\r\n\r\n.stud-head-bg {\r\n  background-color: #efefef;\r\n  color: #333333;\r\n}\r\n\r\n\r\n\r\n.navbar-expand-lg .navbar-nav .nav-link{\r\n  padding-right: 0 !important;\r\n  padding-left: 0 !important;\r\n}\r\n\r\n.footer-head-p{\r\n  padding-right: 1rem !important;\r\n}\r\n\r\n\r\n/* common classes  */\r\n\r\n.z-index-9 {\r\n  z-index: 9;\r\n}\r\n\r\n.maxw-265 {\r\n  max-width: 265px;\r\n  min-width: 265px;\r\n}\r\n\r\n.maxw-450 {\r\n  max-width: 450px;\r\n}\r\n\r\n.maxw-650 {\r\n  max-width: 450px;\r\n}\r\n\r\n\r\n.text-virtu-header, .icon-site-logo-  {\r\n  color: #ffe6c8 !important;\r\n}\r\n\r\n\r\n.body-color-4{\r\n  color: #ffe6c8;\r\n  background: #333333;\r\n}\r\n\r\n/* student page */ \r\n\r\n.section-img {\r\n  max-height: 530px;\r\n  max-width: 530px !important;\r\n}\r\n\r\n\r\n\r\n.blog-body-color{\r\n  background-color: #efefef;\r\n  color: #333333;\r\n}\r\n\r\n.back-to-top {\r\n  display: flex;\r\n  justify-content: end;\r\n}\r\n\r\n.side-bottom {\r\n  width: 2.2vw;\r\n    height: 1.2vw;\r\n    display: inline-block;\r\n    background-position: center!important;\r\n}\r\n\r\n\r\n.footer button:hover span {  \r\n    color: #1c2933 !important;\r\n    background-color: #efefef !important;\r\n}\r\n\r\n/* _________________blogs ________________ */\r\n\r\n.content-margin {\r\n  margin-left: 9vw !important;\r\n  margin-right: 9vw !important;\r\n  padding-bottom: 5rem !important;\r\n}\r\n\r\n\r\n/* -------colour-------- */\r\n\r\n.bg-body-tutor {\r\n  background-color: #e2eecc !important;\r\n  color: #004c4c !important;\r\n}\r\n\r\n\r\n.bg-body-neuro {\r\n  background-color: #e2eecc !important;\r\n  color: #004c4c !important;\r\n}\r\n\r\n.bg-body-education {\r\n  background-color: #c9e8f9;\r\n  color: #37678b; \r\n}\r\n\r\n.bg-body-kaleidoscope {\r\n  background-color: #f6adb8;\r\n  color:#7b3038;\r\n}\r\n\r\n.bg-body-matrix{\r\n  background-color: #7b3038 !important;\r\n  color: #e2eecc; \r\n}\r\n\r\n.bg-body-neuroscience {\r\n  color: #ffe6c8;\r\n  background: #333333;\r\n}\r\n\r\n.bg-body-repetition{\r\n  background-color: var(--bs-bg-body) !important;\r\n  color: var(--bs-text-body) !important;\r\n}\r\n\r\n.bg-body-shadows {\r\nbackground-color: #f6adb8;\r\ncolor:#7b3038;\r\n}\r\n\r\n/* -----navbar------ */\r\n\r\n\r\n\r\n/* --------------- */\r\n\r\n/* --------------- */\r\n\r\n\r\n/* --------------- */\r\n\r\n\r\n\r\n\r\n/* --------------- */\r\n\r\n\r\n\r\n\r\n/* --------------- */\r\n\r\n\r\n/* --------------- */\r\n\r\n/* --------------- */\r\n\r\n\r\n.blogdashSectionActive .text-yellow {\r\ncolor: #e2eecc  !important;\r\n} \r\n\r\n.blogdashSectionActive .bg-dark-footer{\r\nbackground: transparent !important;\r\ncolor: #e2eecc  !important;\r\n}\r\n\r\n.rotateIcon {\r\n  display: inline-block;\r\n  transform-origin: center center;\r\n  animation: rotateY 15s linear infinite alternate; \r\n}\r\n\r\n@keyframes rotateY {\r\n  to {\r\n    transform: rotateY(-360deg);\r\n  }\r\n}\r\n\r\n.icon-checkiconsolid {\r\n  font-size: 40px !important;\r\n  font-weight: 900;\r\n  color: #80B06D;\r\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\r\n}\r\n.icon-site-logo-{\r\n  font-size: 4vh;\r\n}\r\n.montser-lrg, .reg-montser-lrg {\r\n  font-family: 'Montserrat-large' !important;\r\n  font-size: 1vw !important;\r\n  font-weight: 100 !important;\r\n  font-style: normal !important;\r\n}\r\n/* Default layout for larger screens */\r\n.job-container {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n/* Ensure equal left-right margins */\r\n.job-card {\r\n  width: 90%; /* Adjust this to control margin size */\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n/* Center icon on larger screens (non-mobile) */\r\n.icon-container {\r\n  margin-left: 10px;\r\n}\r\n\r\n/* Media query for screens with a max-width of 575px (mobile) */\r\n@media (max-width: 575px) {\r\n  .job-container {\r\n    flex-direction: column; /* Stack content vertically */\r\n    align-items: center; /* Center both description and icon */\r\n    text-align: center; /* Center-align text */\r\n  }\r\n\r\n  .icon-container {\r\n    margin-top: 10px; /* Add spacing between description and icon */\r\n    align-self: center; /* Center the icon below description */\r\n  }\r\n\r\n  .job-card {\r\n    width: 100%; /* Take full width on mobile */\r\n    padding-left: 10vw !important;\r\n    padding-right: 10vw !important;\r\n  }\r\n\r\n  .container-fluid{\r\n    padding-left: 5vw !important;\r\n    padding-right: 5vw !important;\r\n   \r\n  }\r\n}\r\n\r\n/* Center align heading */\r\n.section-heading {\r\n  text-align: center;\r\n  margin-bottom: 1rem;\r\n  font-size: 2rem;\r\n  font-weight: bold;\r\n}\r\n\r\n/* Left align paragraphs */\r\n.paragraph-text {\r\n  text-align: left;\r\n  font-size: 1.2rem !important;\r\n  line-height: 1.6;\r\n}\r\n\r\n/* Responsive adjustments */\r\n@media (max-width: 768px) {\r\n  .section-heading {\r\n    font-size: 1.5rem; /* Smaller heading on tablets */\r\n  }\r\n  .paragraph-text {\r\n    font-size: 0.9rem; /* Slightly smaller paragraphs on mobile */\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .section-heading {\r\n    font-size: 1.3rem; /* Smaller heading on mobile */\r\n  }\r\n  .paragraph-text {\r\n    font-size: 0.8rem; /* Smaller paragraphs on very small screens */\r\n  }\r\n  .v-about {\r\n    display: none !important;\r\n  }\r\n  \r\n  .navbar-nav{\r\n    margin-top: 1rem !important;\r\n  }\r\n}\r\n@media (min-width: 992px) {\r\n  .navbar-expand-lg {\r\n      padding-left: 1.5rem !important;\r\n      padding-right: 1.5rem !important;\r\n  }\r\n\r\n  .mainSectionDiv .container-fluid,.footer-padding{\r\n    padding-left: 2rem;\r\n    padding-right:2rem;\r\n  }\r\n  .btn-md{\r\n    width:15rem !important;\r\n  }\r\n  .v-about button{\r\n    height: 3rem !important;\r\n    width: 15rem !important;\r\n    background: #ffe6c8;\r\n    color: #1c2933 !important;\r\n  }\r\n  \r\n}\r\n.navbar-hidden {\r\n  transform: translateY(-100%);\r\n  transition: transform 0.3s ease-in-out;\r\n}\r\n\r\n.v-about button{\r\n  background: #ffe6c8 !important;\r\n  color: #1c2933 !important;\r\n}\r\n.v-about button:hover{\r\n  background:#1c2933 !important;\r\n  color: #ffe6c8 !important;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
